"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _default = {
  checkGoodUsage: function checkGoodUsage(goodDestinationId) {
    return _apiClient.default.get("cosindex/api/v1/connections/" + goodDestinationId + "/parents", {
      query: {
        levels: 5
      }
    });
  },
  checkPackChildUsage: function checkPackChildUsage(packChildren) {
    return _apiClient.default.get('cosindex/api/v1/connections/parents', {
      query: {
        id: packChildren.toJS(),
        levels: 5
      }
    });
  }
};
exports.default = _default;
module.exports = exports.default;